import PageLayout from '../components/layout/PageLayout'
import StoresList from 'components/lists/stores/StoresList'

export default function StoresPage() {
  return (
    <PageLayout pageTitle='Almacenes' pageDesc='Altas, bajas y modificaciones.'>
      <StoresList/>
    </PageLayout>
  )
}